<app-language-selector class="language-selector"/>

<div class="card">
    <mat-icon class="error-icon ct-error-icon-animated">no_accounts</mat-icon>
    <h1>{{ 'shared.account-deactivated.title' | translate }}</h1>
    <p>{{ 'shared.account-deactivated.message' | translate }}</p>
    <img class="ubi-logo" src="app_logo_black.svg" alt="UBI Solutions">
    <div class="actions">
        <button mat-flat-button color="primary" (click)="refresh()">
            <mat-icon>refresh</mat-icon>
            {{ 'shared.account-deactivated.retry' | translate }}
        </button>
        <button mat-button (click)="logout()">
            <mat-icon>logout</mat-icon>
            {{ 'shared.account-deactivated.logout' | translate }}
        </button>
    </div>
</div>
